import { render, staticRenderFns } from "./helperPage.vue?vue&type=template&id=66819985&scoped=true&"
import script from "./helperPage.vue?vue&type=script&lang=js&"
export * from "./helperPage.vue?vue&type=script&lang=js&"
import style0 from "./helperPage.vue?vue&type=style&index=0&id=66819985&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66819985",
  null
  
)

export default component.exports